module.exports = __webpack_public_path__ + "static/media/Excursiones.051835cb.jpeg";